// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1703":"e80b18d7","3648":"48484966"}[chunkId] + ".chunk.css";
};